import {
  CHALLENGE_DAILY_PROFIT_LOCK_MESSAGE,
  RISK_PROFILE_LOCK_MESSAGE,
  CLOSE_ONLY_MESSAGE,
  CHALLENGE_ENDED_MESSAGE,
} from '../utils/tradingLockMessage.ts';
import { translateFailReason } from './apiDisplayLabels';

function localizePhaseSubject(phaseToken, t) {
  if (!phaseToken) return '';
  const fundedMatch = String(phaseToken).match(/^Phase\s+(\d+)\s+Funded$/i);
  if (fundedMatch) return t('challenge.phaseNFunded', { n: fundedMatch[1] });
  const phaseMatch = String(phaseToken).match(/^Phase\s+(\d+)$/i);
  if (phaseMatch) return t('challenge.phaseN', { n: phaseMatch[1] });
  if (/^Funded$/i.test(phaseToken)) return t('orderPanel.funded');
  return phaseToken;
}

/** Map known English banner constants / dynamic challenge-ended text to i18n. */
export function localizeTradingBannerMessage(message, t) {
  if (!message) return null;
  const raw = String(message).trim();

  const known = {
    [CHALLENGE_DAILY_PROFIT_LOCK_MESSAGE]: t('tradingLock.dailyProfitLock'),
    [RISK_PROFILE_LOCK_MESSAGE]: t('tradingLock.riskLock'),
    [CLOSE_ONLY_MESSAGE]: t('tradingLock.closeOnly'),
    [CHALLENGE_ENDED_MESSAGE]: t('tradingLock.challengeEnded'),
  };
  if (known[raw]) return known[raw];

  // "Phase 1 challenge failed (overall loss). This account is now in view-only mode..."
  let m = raw.match(
    /^(?:(Phase\s+\d+(?:\s+Funded)?|Funded)\s+)?challenge failed(?:\s*\(([^)]+)\))?\.?\s*This account is now in view-only mode\.?\s*You can review your results, but trading is disabled\.?$/i
  );
  if (m) {
    const phase = localizePhaseSubject(m[1], t);
    const reason = translateFailReason(m[2], t);
    return t('tradingLock.challengeFailedBanner', {
      phase: phase ? `${phase} ` : '',
      reason: reason ? ` (${reason})` : '',
    });
  }

  m = raw.match(
    /^(?:(Phase\s+\d+(?:\s+Funded)?|Funded)\s+)?challenge passed\.?\s*This account is now in view-only mode\.?\s*You can review your results, but trading is disabled\.?$/i
  );
  if (m) {
    const phase = localizePhaseSubject(m[1], t);
    return t('tradingLock.challengePassedBanner', {
      phase: phase ? `${phase} ` : '',
    });
  }

  if (
    /^Challenge completed\.?\s*This account is now in view-only mode\.?\s*You can review your results, but trading is disabled\.?$/i.test(
      raw
    )
  ) {
    return t('tradingLock.challengeCompletedBanner');
  }

  return raw;
}
